<template>
  <div id="tab">
    <div class="el-tabs el-tabs--top el-tabs--border-card">
      <div class="el-tabs__header is-top">
        <div class="el-tabs__nav-wrap is-top el-tabs__nav-scroll">
          <div class="el-tabs__nav is-top">
            <div class="el-tabs__item is-top is-active">日志</div>
          </div>
        </div>
      </div>
      <div class="tab_pane_body el-tabs__content">
        <el-card class="box-card" shadow="never">
          <el-form ref="queryFormRef" :model="queryForm" size="small" inline>
            <el-form-item label="日期" prop="billDate.selected">
              <date-picker
                style="width: 100%;"
                v-model="queryForm.billDate.selected"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </date-picker>
            </el-form-item>
            <el-form-item label="用户" prop="operatorID.selected">
              <select-multiple class="query_form_item select_multiple" :select-data="queryForm.operatorID"></select-multiple>
            </el-form-item>
            <el-form-item label="功能模块" prop="functionModule.selected">
              <select-multiple class="query_form_item select_multiple" :select-data="queryForm.functionModule"></select-multiple>
            </el-form-item>
            <el-form-item label="操作类型" prop="operationType.selected">
              <select-multiple class="query_form_item select_multiple" :select-data="queryForm.operationType"></select-multiple>
            </el-form-item>
            <el-form-item label="操作日志" prop="keyWords.selected">
              <el-input
                style="width: 200px;"
                v-model="queryForm.keyWords.selected"
                placeholder="请输入操作日志关键字"
                clearable
                @keyup.enter.native="query">
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="query">查询</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <div class="table" v-loading="loading">
          <el-table ref="table" :data="tableData" style="width: 100%" border stripe height="100%" max-height="100%" size="mini">
            <el-table-column type="index" width="55" align="center"></el-table-column>
            <el-table-column prop="operatorName" label="操作人" width="130"></el-table-column>
            <el-table-column prop="functionModuleFormat" label="功能模块" width="130"></el-table-column>
            <el-table-column prop="operationTypeFormat" label="操作类型" width="130"></el-table-column>
            <el-table-column prop="remarks" label="操作日志" width="300" show-overflow-tooltip></el-table-column>
            <el-table-column prop="source" label="来源" width="100"></el-table-column>
            <el-table-column prop="entryDate" label="时间" width="140">
              <template slot-scope="{row}">
                <span>{{row.entryDate}} {{row.entryTime}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page" :page-sizes="[10, 20, 100]" :page-size="params.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { pickerOptions, toRawType } from '@/assets/js/common.js'
import { iframeLifeCycle } from "@/mixins/iframeLifeCycle";
import datePicker from '@/components/common/datePicker.vue'
export default {
  name: 'Journal',
  mixins: [iframeLifeCycle],
  components: {
    datePicker
  },
  data() {
    return {
      queryForm: {
        billDate: { submitName: 'billDate', selected: [] },
        operatorID: { submitName: 'operatorID', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择用户', request: { url: '/Account/userDefine/selectUserListForVue.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        functionModule: { submitName: 'functionModule', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择功能模块', request: { url: '/Account/UserBehaviorVue/selectFunctionModuleList.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        operationType: { submitName: 'operationType', selected: {}, isFilter: false, valueIsObj: true, isMultiple: true, isAll: false, isShowAll: false,isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择操作类型', request: { url: '/Account/UserBehaviorVue/selectOperationTypeList.html', type: 'post', params: {page: 1, size: 5}, text: '', value: ''}},
        keyWords: { submitName: 'keyWords', selected: ''}
      },
      params: {
        page: 1,
        size: 10
      },
      pickerOptions: pickerOptions,
      tableData: [],
      total: 0
    }
  },
  created() {
    this.query()
  },
  methods: {
    iframeLifeCycleCreated() {
      console.log("🚀 ~ file: Journal.vue:114 ~ iframeLifeCycleCreated ~ iframeLifeCycleCreated:")
    },
    iframeLifeCycleDestroyed() {
      console.log("🚀 ~ file: Journal.vue:114 ~ iframeLifeCycleDestroyed ~ iframeLifeCycleDestroyed:")
    },
    query() {
      this.params.page = 1
      Object.values(this.queryForm).forEach(item => {
        if (item.submitName == 'billDate') {
          console.log(item)
          this.params['beginDate'] = item.selected ? (item.selected[0] || '') : ''
          this.params['endDate'] = item.selected ? (item.selected[1] || '') : ''
          return false
        } else if (toRawType(item.selected) == 'Array') {
          this.params[item.submitName] = item.selected.map(i => "'" + i.value + "'").join(',') || ''
        } else if (toRawType(item.selected) == 'String') {
          this.params[item.submitName] = (item.selected || '').trim()
        } else if (toRawType(item.selected) == 'Number') {
          this.params[item.submitName] = item.selected || 0
        } else if (toRawType(item.selected) == 'Object') {
          if (item.submitName == 'sort') {
            this.params['sortField'] = item.selected.sortField || ''
            this.params['softBy'] = item.selected.softBy || ''
            return false
          }
          this.params[item.submitName] = item.selected.value || ''
        }
      })
      this.getTableList()
    },
    getTableList() {
      this.loading = true
      this.$http.post('/Account/UserBehaviorVue/selectBehaviorList.html', this.Qs.stringify(this.params)).then(({ data: res }) => {
        console.log(res)
        this.loading = false
        if (res.code != 'success') return this.$message.error(res.message)
        let result = JSON.parse(res.result)
        this.tableData = JSON.parse(result.data)
        this.total = result.total
      })
    },
    handleSizeChange (newSize) {
      this.params.size = newSize
      this.getTableList()
    },
    handleCurrentChange (newPage) {
      this.params.page = newPage
      this.getTableList()
    },
  }
}
</script>

<style lang="less" scoped>
  .select_multiple {
    width: 100%;
    ::v-deep .el-select__tags {
      max-height: 30px;
      overflow-y: auto;
      overflow-x: hidden;
    }
  }
.el-tabs {
  height: 100%;
  box-sizing: border-box;
  .el-tabs__item {
    height: 32px;
    line-height: 32px;
  }
  .tab_pane_body {
    height: calc(100% - 32px);
    box-sizing: border-box;
    padding: 0 12px;
    ::v-deep .el-card {
      .el-card__body {
        padding: 12px;
        .el-form {
          margin-top: -12px;
          display: flex;
          .el-form-item {
            margin: 18px 0 0;
            position: relative;
            & + .el-form-item {
              margin-left: 10px;
            }
            .el-form-item__label {
              position: absolute;
              z-index: 2;
              top: -12px;
              margin-left: 10px;
              padding: 0 6px;
              line-height: normal;
              background-color: #fff;
            }
            .amt-info {
              border: 1px #F56C6C solid;
              color: #F56C6C;
              span {
                display: block;
                text-align: center;
              }
            }
          }
        }
      }
    }
    .table {
      height: calc(100% - 63px - 32px - 10px);
    }
  }
}
</style>